import axios from 'axios';

// Base API URL - use environment variable or fallback
const BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://apipubtracker.wellhaven.net' // ← Your new backend subdomain
    : 'http://localhost:5000');

// Function to make requests with optional individual headers
export const fetchData = async (tokens = []) => {
  try {
    // Use the backend proxy endpoint
    const response = await axios.get(`${BASE_URL}/api/proxy`);
    console.log('Final API Responses:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
